export class DashboardGeneratorHtml {
  generatorskin() {
    return `
      <div class="container-layout d-grid grid-2">
        <!-- ================== GENERATOR SUMMARY ================== -->
        <div class="container-column">
          <div class="column-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mingcute:performance-line"></span>
              <h3>Generator Summary Data</h3>
              <div class="header-actions">
                <button class="full-screen-button" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="container-body">
            <div class="table-responsive">
              <div class="has-min-width d-flex flex-column gap-20">
                <div class="d-flex gap-10">
                  <div class="d-flex justify-space-between w-100 min-w-300"><span>Fuel Level</span><span>%</span></div>
                  <div class="text-right bg-subcontainer w-100 max-w-100" data-register="DG Meter Fuel Level">0</div>
                </div>
                <div class="d-flex gap-10">
                  <div class="d-flex justify-space-between w-100 min-w-300"><span>Voltage</span><span>V</span></div>
                  <div class="text-right bg-subcontainer w-100 max-w-100" data-register="DG Meter Voltage Phase A">0</div>
                </div>
                <div class="d-flex gap-10">
                  <div class="d-flex justify-space-between w-100 min-w-300"><span>Current</span><span>A</span></div>
                  <div class="text-right bg-subcontainer w-100 max-w-100" data-register="DG Meter Current Phase A">0</div>
                </div>
                <div class="d-flex gap-10">
                  <div class="d-flex justify-space-between w-100 min-w-300"><span>Frequency</span><span>Hz</span></div>
                  <div class="text-right bg-subcontainer w-100 max-w-100" data-register="DG Meter Frequency">0</div>
                </div>
                <div class="d-flex gap-10">
                  <div class="d-flex justify-space-between w-100 min-w-300"><span>Oil Pressure</span><span></span></div>
                  <div class="text-right bg-subcontainer w-100 max-w-100" data-register="DG Meter Oil Pressure">0</div>
                </div>
                <div class="d-flex gap-10">
                  <div class="d-flex justify-space-between w-100 min-w-300"><span>Active Power</span><span>MW</span></div>
                  <div class="text-right bg-subcontainer w-100 max-w-100" data-register="DG Meter Active Power">0</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ================== REMOTE CONTROL ================== -->
        <div class="container-column remote-control">
          <div class="column-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mingcute:performance-line"></span>
              <h3>Remote Control</h3>
              <div class="header-actions">
                <button class="full-screen-button" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="container-body">
            <div class="table-responsive">
              <table class="has-min-width">
                <thead>
                  <tr>
                    <th colspan="2"></th>
                    <th>DG 1</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Active Power</td>
                    <td class="w-100 text-right">MW</td>
                    <td class="text-right w-100 bg-subcontainer">0</td>
                  </tr>
                  <tr>
                    <td>Frequency</td>
                    <td class="w-100 text-right">Hz</td>
                    <td class="text-right w-100 bg-subcontainer">0</td>
                  </tr>
                  <tr>
                    <td>Engine Speed</td>
                    <td class="w-100 text-right">rpm</td>
                    <td class="text-right w-100 bg-subcontainer">0</td>
                  </tr>
                  <tr>
                    <td>Fuel Level</td>
                    <td class="w-100 text-right">%</td>
                    <td class="text-right w-100 bg-subcontainer">0</td>
                  </tr>
                  <tr>
                    <td>Voltage</td>
                    <td class="w-100 text-right">V</td>
                    <td class="text-right w-100 bg-subcontainer">0</td>
                  </tr>
                  <tr>
                    <td>Current</td>
                    <td class="w-100 text-right">A</td>
                    <td class="text-right w-100 bg-subcontainer">0</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="container-column">
          <div class="column-header">
            <div class="header-title has-icon">
              <h3>Engine Fuel Level</h3>
              <div class="header-actions d-flex align-center gap-10">
                <span class="date-display" id="engine_fuel_gauge_chart_display"></span>
                <input type="hidden" id="engine_fuel_gauge_chart_start">
                <input type="hidden" id="engine_fuel_gauge_chart_end">
                <button class="date-range-button" title="Select Date Range" id="engine_fuel_gauge_chart_picker">
                  <span class="iconify" data-icon="mdi:calendar-range"></span>
                </button>
                <button class="full-screen-button" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="engine_fuel_gauge">
                
            </div>
          </div>
        </div>

        <!-- ================== CHARTS ================== -->
        <div class="container-column">
          <div class="column-header">
            <div class="header-title has-icon">
              <h3>Engines Power vs Frequency</h3>
              <div class="header-actions d-flex align-center gap-10">
                <span class="date-display" id="engines_power_vs_frequency_chart_display"></span>
                <input type="hidden" id="engines_power_vs_frequency_chart_start">
                <input type="hidden" id="engines_power_vs_frequency_chart_end">
                <button class="date-range-button" title="Select Date Range" id="engines_power_vs_frequency_chart_picker">
                  <span class="iconify" data-icon="mdi:calendar-range"></span>
                </button>
                <button class="full-screen-button" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="engines_power_vs_frequency">
                <div class="chart-type-toggle">
                    <select>
                        <option value="lines">Line</option>
                        <option value="markers">Scatter (Markers)</option>
                        <option value="lines+markers">Line + Markers</option>
                        <option value="bar">Bar</option>
                        <option value="area">Area (Filled Line)</option>
                        <option value="spline">Spline</option>
                    </select>
                </div>
            </div>
          </div>
        </div>

        <div class="container-column">
          <div class="column-header">
            <div class="header-title has-icon">
              <h3>Engine Fuel Level</h3>
              <div class="header-actions d-flex align-center gap-10">
                <span class="date-display" id="engine_fuel_level_datatable_chart_display"></span>
                <input type="hidden" id="engine_fuel_level_datatable_chart_start">
                <input type="hidden" id="engine_fuel_level_datatable_chart_end">
                <button class="date-range-button" title="Select Date Range" id="engine_fuel_level_datatable_chart_picker">
                  <span class="iconify" data-icon="mdi:calendar-range"></span>
                </button>
                <button class="full-screen-button" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="engine_fuel_level_datatable">
                <div class="chart-type-toggle">
                    <select>
                        <option value="lines">Line</option>
                        <option value="markers">Scatter (Markers)</option>
                        <option value="lines+markers">Line + Markers</option>
                        <option value="bar">Bar</option>
                        <option value="area">Area (Filled Line)</option>
                        <option value="spline">Spline</option>
                    </select>
                </div>
            </div>
          </div>
        </div>

        <div class="container-column">
          <div class="column-header">
            <div class="header-title has-icon">
              <h3>Engines Active Power</h3>
              <div class="header-actions d-flex align-center gap-10">
                <span class="date-display" id="engines_active_power_chart_display"></span>
                <input type="hidden" id="engines_active_power_chart_start">
                <input type="hidden" id="engines_active_power_chart_end">
                <button class="date-range-button" title="Select Date Range" id="engines_active_power_chart_picker">
                  <span class="iconify" data-icon="mdi:calendar-range"></span>
                </button>
                <button class="full-screen-button" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="engines_active_power">
                <div class="chart-type-toggle">
                    <select>
                        <option value="lines">Line</option>
                        <option value="markers">Scatter (Markers)</option>
                        <option value="lines+markers">Line + Markers</option>
                        <option value="bar">Bar</option>
                        <option value="area">Area (Filled Line)</option>
                        <option value="spline">Spline</option>
                    </select>
                </div>
            </div>
          </div>
        </div>

        <div class="container-column">
          <div class="column-header">
            <div class="header-title has-icon">
              <h3>Engine Reactive Power</h3>
              <div class="header-actions d-flex align-center gap-10">
                <span class="date-display" id="engine_reactive_power_chart_display"></span>
                <input type="hidden" id="engine_reactive_power_chart_start">
                <input type="hidden" id="engine_reactive_power_chart_end">
                <button class="date-range-button" title="Select Date Range" id="engine_reactive_power_chart_picker">
                  <span class="iconify" data-icon="mdi:calendar-range"></span>
                </button>
                <button class="full-screen-button" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="engine_reactive_power">
                <div class="chart-type-toggle">
                    <select>
                        <option value="lines">Line</option>
                        <option value="markers">Scatter (Markers)</option>
                        <option value="lines+markers">Line + Markers</option>
                        <option value="bar">Bar</option>
                        <option value="area">Area (Filled Line)</option>
                        <option value="spline">Spline</option>
                    </select>
                </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
